module.exports = __webpack_public_path__ + "img/1280x720-Nature.03a7891f.jpg";